<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('claimPayout.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('claimPayout.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex ts-justify-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('add_new')
            }}
          </ts-button>
                    <div class="ts-flex">
            <div class="ts-w-64">
              <ts-input
                v-model="search"
                :placeholder="$t('dealerWithdrawal.search')"
                style="width: 250px;"
                class="inline-block"
              />
            </div>
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
            <!-- drawer filter date -->
            <a-drawer
              :title="$t('filter')"
              placement="right"
              :closable="false"
              :visible="visible"
              @close="visible = false"
              :zIndex="1020"
              width="300px"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <a-range-picker
                      format="DD-MM-YYYY"
                      :defaultValue="rangeDate"
                      :defaultPickerValue="rangeDate"
                      valueFormat="DD-MM-YYYY"
                      @change="dateRangeChange"
                    >
                      <template slot="renderExtraFooter"></template>
                    </a-range-picker>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.tran_no }}</td>
          <td>{{ record.dealer.dealer_name }}</td>
          <td>{{ record.tran_date }}</td>
          <td>{{ record.transaction_type.tran_type }}</td>
          <td>
            <span
              :class="
                record.beginning_balance < 0
                  ? 'ts-text-red-600'
                  : 'ts-text-green-600'
              "
              class="ts-font-extrabold"
            >{{ number_form(record.beginning_balance) }}</span>
          </td>

          <td>
            <span class="ts-font-extrabold ts-text-red-600">{{ '-' + number_form(record.amount) }}</span>
          </td>
          <td>
            <span
              :class="
                record.ending_balance < 0
                  ? 'ts-text-red-600'
                  : 'ts-text-green-600'
              "
              class="ts-font-extrabold"
            >{{ number_form(record.ending_balance) }}</span>
          </td>
          <td>{{ record.user.name }}</td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <!-- show form search dealer profile -->
    <a-modal
      v-if="show_form_create"
      v-model="show_form_create"
      :title="$t('claimPayout.pageTitle')"
      :okText="$t('save')"
      :cancelText="$t('cancel')"
      :footer="null"
      :zIndex="1020"
      :maskClosable="false"
      :centered="true"
      width="400px"
      @cancel="onClose"
    >
      <FrmSearchDealer @close="onClose" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import FrmSearchDealer from './components/frm_search_dealer'

export default {
  name: 'gameBetting',
  components: {
    FrmSearchDealer
  },
  data() {
    return {
      visible: false,
      loading: false,
      show_form_create: false,
      model: {
        claim_amount: null,
        dealer_id: null,
        description: null,
        payout_balance: 0
      },
      rangeDate: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('accounting/claimPayout', ['resources', 'pagination']),
    number_form: () => value => {
      return parseFloat(value).toFixed(2)
    },
    search: {
      get() {
        return this.$store.state.accounting.dealerWithdrawal.search
      },
      set(newValue) {
        this.$store.commit('accounting/dealerWithdrawal/SET_SEARCH', newValue)
        this.$store.commit('accounting/dealerWithdrawal/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('dealerWithdrawal.tranNo') },
        { name: this.$t('dealerWithdrawal.dealerName') },
        { name: this.$t('dealerWithdrawal.tranDate') },
        { name: this.$t('dealerWithdrawal.transactionType') },
        { name: this.$t('dealerWithdrawal.startBalance') },
        { name: this.$t('dealerWithdrawal.amount') },
        { name: this.$t('dealerWithdrawal.endingBalance') },
        { name: this.$t('dealerWithdrawal.createdBy'), style: 'width:10%' }
        // { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    addNew() {
      this.show_form_create = true
    },
    onClose() {
      this.show_form_create = false
      this.fetchData()
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('accounting/claimPayout/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit('accounting/dealerWithdrawal/SET_DATE_FROM', dateRange[0])
      this.$store.commit('accounting/dealerWithdrawal/SET_DATE_TO',dateRange[1])
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('accounting/claimPayout/RESET_STATE')
    next()
  }
}
</script>
